<template>
  <el-dialog :visible.sync="visible" :title="'任务信息审核'" :close-on-click-modal="false" :close-on-press-escape="false">
    <el-form :model="dataForm" :rules="dataRule" ref="dataForm" :label-width="$i18n.locale === 'en-US' ? '120px' : '140px'">
      <el-form-item label="任务发布编号" prop="taskCode">
        <el-input v-model="dataForm.taskCode" placeholder="任务发布编号" :disabled="true" style="border: none"></el-input>
      </el-form-item>
      <el-form-item label="任务大类" prop="taskType">
        <ren-select v-model="dataForm.taskType" dict-type="taskType" isDisabled=true></ren-select>
      </el-form-item>
      <el-form-item label="任务简述" prop="taskDesc">
        <el-input v-model="dataForm.taskDesc" placeholder="任务简述" :disabled="true"></el-input>
      </el-form-item>
      <el-form-item label="结算价格及结算方式" prop="taskRequire">
        <el-input type="textarea" rows="4" v-model="dataForm.taskRequire" placeholder="结算价格及结算方式" :disabled="true"></el-input>
      </el-form-item>
      <el-form-item label="需求人数" prop="requirePerson">
        <el-input v-model="dataForm.requirePerson" placeholder="需求人数" :disabled="true"></el-input>
      </el-form-item>
      <el-form-item label="预算金额" prop="budget">
        <el-input v-model="dataForm.budget" placeholder="预算金额" :disabled="true"></el-input>
      </el-form-item>
      <el-form-item label="关联合同编号" prop="contractCode">
        <el-input v-model="dataForm.contractCode" placeholder="合同编号" :disabled="true"></el-input>
      </el-form-item>
      <el-form-item label="任务周期" prop="startDate">
        <el-date-picker v-model="dataForm.startDate" start-placeholder="开始日期" type="datetime" format="yyyy-MM-dd" value-format="yyyy-MM-dd HH:mm:ss" :disabled="true"></el-date-picker>
        ~
        <el-date-picker v-model="dataForm.endDate" end-placeholder="结束日期" type="datetime" format="yyyy-MM-dd" value-format="yyyy-MM-dd HH:mm:ss" :disabled="true"></el-date-picker>
      </el-form-item>
      <template>
        <el-table :data="dataForm.processDTOList" style="width: 100%">
          <el-table-column prop="status" label="节点" width="100" show-overflow-tooltip>
            <template slot-scope="scope">
              {{ $getDictLabel("taskStatus", scope.row.status) }}
            </template>
          </el-table-column>
          <el-table-column prop="realName" label="审核人" width="100">
          </el-table-column>
          <el-table-column prop="createDate" label="审核时间">
          </el-table-column>
          <el-table-column prop="operation" label="操作">
          </el-table-column>
          <el-table-column prop="content" label="审核意见" show-overflow-tooltip>
          </el-table-column>
        </el-table>
      </template>
      <div v-show="dataForm.status!=3 && dataForm.status!=0">
        <el-form-item label="审核意见" prop="content">
          <el-input type="textarea" v-model="dataForm.content" maxlength="50" show-word-limit></el-input>
        </el-form-item>
      </div>
    </el-form>
    <template slot="footer">
        <el-button v-show="dataForm.status===1 || dataForm.status===2" type="primary" @click="dataFormSubmitHandle('1',dataForm.id)">通过审核</el-button>
        <el-button v-show="dataForm.status===1 || dataForm.status===2" type="primary" style="background-color: thistle" @click="dataFormSubmitHandle('0',dataForm.id)">驳回</el-button>
        <el-button @click="visible = false">{{ $t('cancel') }}</el-button>
    </template>
  </el-dialog>
</template>

<script>
import debounce from 'lodash/debounce'
export default {
  data () {
    return {
      dataForm: {
        id: '',
        taskDesc: '',
        taskRequire: '',
        requirePerson: '',
        budget: '',
        contractCode: '',
        startDate: '',
        endDate: '',
        status: '',
        creator: '',
        createDate: '',
        updater: '',
        updateDate: '',
        taskCode: '',
        taskType: '',
        taskStatus: '',
        content: '',
        processDTOList: []
      },
      visible: false

    }
  },
  computed: {
    dataRule () {
      return {
        content: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ]
      }
    }
  },
  created () {
    this.getContract()
  },
  methods: {
    getContract () {
      this.$http.get(`/sys/plat/contract/getContractCodeList`).then(({ data: res }) => {
        if (res.code !== 0) {
          return this.$message.error(res.msg)
        }
        this.options = res.data
      }).catch(() => {})
    },
    init () {
      this.visible = true
      this.$nextTick(() => {
        this.$refs['dataForm'].resetFields()
        if (this.dataForm.id) {
          this.getInfo()
        }
      })
    },
    // 获取信息
    getInfo () {
      let that = this
      this.$http.get(`/sys/plat/task/${this.dataForm.id}`).then(({ data: res }) => {
        if (res.code !== 0) {
          return this.$message.error(res.msg)
        }
        that.dataForm = {
          ...that.dataForm,
          ...res.data
        }
      }).catch(() => {})
    },
    // 表单提交
    dataFormSubmitHandle: debounce(function (inStatus, id) {
      let _this = this
      this.$refs['dataForm'].validate((valid) => {
        if (!valid) {
          return false
        }
        this.$http.post('/sys/plat/task/audit?inStatus=' + inStatus + '&content=' + _this.dataForm.content + '&id=' + id, {
          headers: {
            'content-type': 'application/json;charset=utf-8'
          }
        }).then(({ data: res }) => {
          if (res.code !== 0) {
            return this.$message.error(res.msg)
          }
          this.$message({
            message: this.$t('prompt.success'),
            type: 'success',
            duration: 500,
            onClose: () => {
              this.visible = false
              this.$emit('refreshDataList')
            }
          })
        }).catch(() => {})
      })
    }, 1000, { 'leading': true, 'trailing': false })
  }
}
</script>
<style>
  .el-table td, .el-table th{
    text-align: center !important;
  }
</style>
